import {
	MATTRESS_TOPPERS_PATH,
	MATTRESSES_PATH,
	MEAT_DELIVERY_SERVICES_PATH,
	PET_FOOD_DELIVERY_PATH,
	PROMOTIONAL_PRODUCTS_PATH,
	SOLAR_PATH,
	SURVEY_SITES_PATH,
	TEA_CLUBS_PATH,
} from "../../../../config/site/favy";

export const styles = (vertical) => ({
	mainContainer: `tw:px-4 tw:mx-auto tw:max-w-[550px] tw:xl:px-0 ${FAVY_COLUMNS_VERTICALS.includes(vertical) ? "tw:desktop:max-w-1170px" : "tw:lg:max-w-1170px"}`,
	companyListContainer: "tw:w-full",
	paginationContainer:
		"tw:mt-10 tw:mb-8 tw:flex tw:justify-between tw:gap-2 tw:sm:justify-center tw:sm:mx-auto",
	pageLink:
		"tw:hidden tw:text-[#4A5059] tw:text-center tw:bg-white tw:capitalize tw:py-2 tw:px-4 tw:text-sm tw:font-medium tw:leading-6 tw:shadow-[0px_4px_24px_-4px_rgba(90,97,107,0.07),0px_2px_6px_-2px_rgba(90,97,107,0.07),0px_1px_3px_-1px_rgba(90,97,107,0.07),0px_0px_1px_0px_rgba(90,97,107,0.25)] tw:rounded-[12px] tw:border-[0.5px] tw:border-solid tw:border-[rgba(22,34,51,0.07)] tw:sm:inline-flex",
	previousLink: "tw:inline-flex! tw:mr-6",
	nextLink: "tw:inline-flex! tw:ml-6",
	activeLink: "tw:bg-[#e1255b]! tw:text-white!",
	disabledLink: "tw:opacity-50 tw:cursor-not-allowed",
});

const FAVY_COLUMNS_VERTICALS = [
	MATTRESS_TOPPERS_PATH,
	MATTRESSES_PATH,
	MEAT_DELIVERY_SERVICES_PATH,
	PET_FOOD_DELIVERY_PATH,
	PROMOTIONAL_PRODUCTS_PATH,
	SOLAR_PATH,
	SURVEY_SITES_PATH,
	TEA_CLUBS_PATH,
];
